/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_TitleInputs */

const zh_subscription_title = /** @type {(inputs: Subscription_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅管理`)
};

const en_subscription_title = /** @type {(inputs: Subscription_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription Management`)
};

const es_subscription_title = /** @type {(inputs: Subscription_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de suscripciones`)
};

/**
* | output |
* | --- |
* | "Subscription Management" |
*
* @param {Subscription_TitleInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const subscription_title = /** @type {((inputs?: Subscription_TitleInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_TitleInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_title(inputs)
	if (locale === "en") return en_subscription_title(inputs)
	return es_subscription_title(inputs)
});